// extracted by mini-css-extract-plugin
module.exports = {"McsNavBlogPrevNextBase":"McsNavBlogPrevNext_McsNavBlogPrevNextBase__2J6ff","McsNavBlogPrevNextLink":"McsNavBlogPrevNext_McsNavBlogPrevNextLink__3Ts6A"};